import footer from "../../../../image/footer.png";
import ElementContext from "../ElementModal";
import {
  Alert,
  ProgressIndicator,
  BadgeNotification,
  SnackbarNotification,
  Spinner,
  ToastNotification,
  GeoLocationFeedback,
  UserFeedbackWidget,
  DragAndDrop,
} from "../../../../../../../../constants/db";

interface ImageTextObject {
  image: string;
  text: string;
  sourceCode: string;
  description: string;
}

const textLists: ImageTextObject[] = [
  {
    image: footer,
    text: "Alert",
    sourceCode: Alert.code,
    description: Alert.description,
  },
  {
    image: footer,
    text: "Progress Indicators",
    sourceCode: ProgressIndicator.code,
    description: ProgressIndicator.description,
  },
  {
    image: footer,
    text: "Badge Notifications",
    sourceCode: BadgeNotification.code,
    description: BadgeNotification.description,
  },
  {
    image: footer,
    text: "Snackbar Notifications",
    sourceCode: SnackbarNotification.code,
    description: SnackbarNotification.description,
  },
  {
    image: footer,
    text: "Spinner",
    sourceCode: Spinner.code,
    description: Spinner.description,
  },
  {
    image: footer,
    text: "Toast Notifications",
    sourceCode: ToastNotification.code,
    description: ToastNotification.description,
  },
  {
    image: footer,
    text: "Geo-location Feedback",
    sourceCode: GeoLocationFeedback.code,
    description: GeoLocationFeedback.description,
  },
  {
    image: footer,
    text: "User Feedback Widgets",
    sourceCode: UserFeedbackWidget.code,
    description: UserFeedbackWidget.description,
  },
  {
    image: footer,
    text: "Drag-and-Drop",
    sourceCode: DragAndDrop.code,
    description: DragAndDrop.description,
  },
];

export default function FeedbackPage() {
  return (
    <section className="layoutPages">
      {" "}
      <h2 className="layoutPages_heading">Feedback components</h2>
      <p className="layoutPages_info">
        Here is a list of all the prebuilt form components that PlayBox makes
        available for use.
      </p>
      {/* compoonets */}
      <div>
        <ElementContext imageTextArray={textLists} />
      </div>
      <p className="coming-soon"> More coming soon ✌️ </p>
    </section>
  );
}
